<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="tabela.busca" v-if="!addUser" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">TURMAS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text @click="criarNovo" tile color="#00695C">
            <v-icon left dark>add_circle</v-icon>Cadastrar
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editItem(item)">edit</v-icon>
        <v-icon medium @click="deleteItem(item)">delete</v-icon>
      </template>
      <template v-slot:[`item.ativo`]="{ item }">
        <v-icon v-if="item.ativo == true" color="success">circle</v-icon>
        <v-icon v-else color="error">circle</v-icon>
      </template>
      <template v-slot:[`item.cor`]="{ item }">
        <v-card :color="item.cor">
          <p :style="`color:${item.cor}; margin: 0px`">{{ item.cor  }}</p>
        </v-card>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum divulgador encontrado</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else style="border-radius: 10px;">
      <template v-if="adicionarDivulgador">
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#00695C"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C"></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.idadeMinima" outlined label="Idade mínima" color="#00695C" type="tel"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.idadeMaxima" outlined label="Idade máxima" color="#00695C" type="tel"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00695C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#00695C" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      addUser: false,
      adicionarDivulgador: false,
      temInscritos: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Idade Mínima', value: 'idadeMinima' },
          { text: 'Idade Máxima', value: 'idadeMaxima' },
          { text: 'Ações', value: 'action', align: 'center', sortable: false },
        ],
        conteudo: []
      },
      editedIndex: -1,
      editedItem: {
        idadeMinima: 1,
        idadeMaxima: 10,
        nome: '',
      },
      defaultItem: {
        nome: '',
        idadeMinima: 1,
        idadeMaxima: 10,
      },
      eventos: [],
      eventoId: '',
      eventoIdAtual: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVA TURMA ' : 'EDITAR TURMA'
      }
    }),

    mounted() {
      this.carregaTurmas()
      
    },

    watch: {
      
    },

    methods: {
      async carregaTurmas() {
        await axios.get(baseApiUrl + 'Turmas?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "order": "nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data 
          }
        })
      },

      criarNovo() {
        this.adicionarDivulgador = true
        this.addUser = true
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.adicionarDivulgador = true
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir a turma: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Turmas/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.eventoIdAtual = this.eventoId
            this.carregaTurmas()
          })
        }
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true
        var vm = this;
        if (this.editedIndex != -1) {
          if (this.editedItem.nome  && this.editedItem.idadeMinima && this.editedItem.idadeMaxima) {
            await axios.patch(`${baseApiUrl}Turmas/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
                this.carregaTurmas()
                this.close()
              }
            }).catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        } else {
          if (this.editedItem.nome &&  this.editedItem.idadeMaxima && this.editedItem.idadeMinima ) {
            this.editedItem.igrejaId = this.user.igrejaId
              await axios.post(`${baseApiUrl}Turmas/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Turma cadastrada com sucesso!", "INFORMAÇÃO")
                this.carregaTurmas()
                this.close()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar turma, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        }

        this.isLoading = false
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>